import CSV from "./Content/images/file-types/csv.png";
import EXCEL from "./Content/images/file-types/excel.png";
import IMG from "./Content/images/file-types/img.png";
import PDF from "./Content/images/file-types/pdf.png";
import PPT from "./Content/images/file-types/ppt.png";
import TEXT from "./Content/images/file-types/txt.png";
import WORD from "./Content/images/file-types/word.png";
import INVALID from "./Content/images/file-types/invalid.png";
import React from "react";
import { RestrictedDomains, PersonalEmailDomains } from "./Components/Signup/RestrictedDomain";
import Axios from "./Axios/Axios";
import { Urls } from "./Urls";
import { ENABLE_SMS, ENV } from "./config/env.config";
export {
  ENV,
  NODE_ENV,
  PUBLIC_URL,
  MIXPANEL_TOKEN,
  IS_DEV,
  IS_STAGING,
  IS_PREPROD,
  IS_PROD,
  STORAGE_ACCOUNT,
  DECRPTION_KEY_HEX,
  GOOGLE_ID,
  GOOGLE_MAP_API_KEY,
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
} from "./config/env.config";

export {
  API_BASE_URL,
  API_LOGO_BASE_URL,
  PPT_URL,
} from "./Urls";

export const Constants = {
  Currency: [
    {
      cc: "AED",
      symbol: "د.إ.",
      name: "UAE dirham",
    },
    {
      cc: "AFN",
      symbol: "؋",
      name: "Afghan afghani",
    },
    {
      cc: "ALL",
      symbol: "L",
      name: "Albanian lek",
    },
    {
      cc: "AMD",
      symbol: "դր",
      name: "Armenian dram",
    },
    {
      cc: "ANG",
      symbol: "ƒ",
      name: "Netherlands Antillean guilder",
    },
    {
      cc: "AOA",
      symbol: "Kz",
      name: "Angolan kwanza",
    },
    {
      cc: "ARS",
      symbol: "$",
      name: "Argentine peso",
    },
    {
      cc: "AUD",
      symbol: "$",
      name: "Australian dollar",
    },
    {
      cc: "AWG",
      symbol: "ƒ",
      name: "Aruban florin",
    },
    {
      cc: "AZN",
      symbol: "₼",
      name: "Azerbaijani manat",
    },
    {
      cc: "BAM",
      symbol: "КМ",
      name: "Bosnia-Herzegovina convertible mark",
    },
    {
      cc: "BBD",
      symbol: "$",
      name: "Barbadian dollar",
    },
    {
      cc: "BDT",
      symbol: "৳",
      name: "Bangladeshi taka",
    },
    {
      cc: "BGN",
      symbol: "лв.",
      name: "Bulgarian lev",
    },
    {
      cc: "BHD",
      symbol: "د.ب.",
      name: "Bahraini dinar",
    },
    {
      cc: "BIF",
      symbol: "FBu",
      name: "Burundian franc",
    },
    {
      cc: "BMD",
      symbol: "$",
      name: "Bermudian dollar",
    },
    {
      cc: "BND",
      symbol: "$",
      name: "Brunei dollar",
    },
    {
      cc: "BOB",
      symbol: "Bs.",
      name: "Bolivian boliviano",
    },
    {
      cc: "BRL",
      symbol: "R$",
      name: "Brazilian real",
    },
    {
      cc: "BSD",
      symbol: "$",
      name: "Bahamian dollar",
    },
    {
      cc: "BTN",
      symbol: "Nu.",
      name: "Bhutanese ngultrum",
    },
    {
      cc: "BWP",
      symbol: "P",
      name: "Botswana pula",
    },
    {
      cc: "BYN",
      symbol: "руб.",
      name: "Belarusian ruble",
    },
    {
      cc: "BZD",
      symbol: "$",
      name: "Belize dollar",
    },
    {
      cc: "CAD",
      symbol: "$",
      name: "Canadian dollar",
    },
    {
      cc: "CDF",
      symbol: "₣",
      name: "Congolese franc",
    },
    {
      cc: "CHF",
      symbol: "₣",
      name: "Swiss franc",
    },
    {
      cc: "CKD",
      symbol: "$",
      name: "Cook Islands dollar",
    },
    {
      cc: "CLP",
      symbol: "$",
      name: "Chilean peso",
    },
    {
      cc: "CNY",
      symbol: "¥元",
      name: "Chinese yuan",
    },
    {
      cc: "COP",
      symbol: "$",
      name: "Colombian peso",
    },
    {
      cc: "CRC",
      symbol: "₡",
      name: "Costa Rican colón",
    },
    {
      cc: "CUC",
      symbol: "$",
      name: "Cuban Convertible peso",
    },
    {
      cc: "CUP",
      symbol: "₱",
      name: "Cuban peso",
    },
    {
      cc: "CVE",
      symbol: "$",
      name: "Cabo Verdean escudo",
    },
    {
      cc: "CZK",
      symbol: "Kč",
      name: "Czech koruna",
    },
    {
      cc: "DJF",
      symbol: "ف.ج.",
      name: "Djiboutian franc",
    },
    {
      cc: "DKK",
      symbol: "kr.",
      name: "Danish krone",
    },
    {
      cc: "DOP",
      symbol: "$",
      name: "Dominican peso",
    },
    {
      cc: "DZD",
      symbol: "د.ج.",
      name: "Algerian dinar",
    },
    {
      cc: "EGP",
      symbol: "ج.م.",
      name: "Egyptian pound",
    },
    {
      cc: "EHP",
      symbol: "Ptas.",
      name: "Sahrawi peseta",
    },
    {
      cc: "ERN",
      symbol: "ناكفا",
      name: "Eritrean nakfa",
    },
    {
      cc: "ETB",
      symbol: "ብር",
      name: "Ethiopian birr",
    },
    {
      cc: "EUR",
      symbol: "€",
      name: " euro",
    },
    {
      cc: "FJD",
      symbol: "$",
      name: "Fijian dollar",
    },
    {
      cc: "FKP",
      symbol: "£",
      name: "Falkland Islands pound",
    },
    {
      cc: "FOK",
      symbol: "kr",
      name: "Faroese króna",
    },
    {
      cc: "GBP",
      symbol: "£",
      name: "Pound Sterling pound",
    },
    {
      cc: "GEL",
      symbol: "₾",
      name: "Georgian lari",
    },
    {
      cc: "GGP",
      symbol: "£",
      name: "Guernsey pound",
    },
    {
      cc: "GHS",
      symbol: "₵",
      name: "Ghanaian cedi",
    },
    {
      cc: "GIP",
      symbol: "£",
      name: "Gibraltar pound",
    },
    {
      cc: "GMD",
      symbol: "D",
      name: "Gambian dalasi",
    },
    {
      cc: "GNF",
      symbol: "FG",
      name: "Guinean franc",
    },
    {
      cc: "GTQ",
      symbol: "$",
      name: "Guatemalan quetzal",
    },
    {
      cc: "GYD",
      symbol: "$",
      name: "Guyanese dollar",
    },
    {
      cc: "HKD",
      symbol: "$",
      name: "Hong Kong dollar",
    },
    {
      cc: "HNL",
      symbol: "L",
      name: "Honduran lempira",
    },
    {
      cc: "HRK",
      symbol: "kn",
      name: "Croatian kuna",
    },
    {
      cc: "HTG",
      symbol: "G",
      name: "Haitian gourde",
    },
    {
      cc: "HUF",
      symbol: "Ft",
      name: "Hungarian forint",
    },
    {
      cc: "IDR",
      symbol: "Rp",
      name: "Indonesian rupiah",
    },
    {
      cc: "ILS",
      symbol: "₪",
      name: "Israeli shekel",
    },
    {
      cc: "IMP",
      symbol: "£",
      name: "Manx pound",
    },
    {
      cc: "INR",
      symbol: "₹",
      name: "Indian rupee",
    },
    {
      cc: "IQD",
      symbol: "د.ع.",
      name: "Iraqi dinar",
    },
    {
      cc: "IRR",
      symbol: "﷼",
      name: "Iranian rial",
    },
    {
      cc: "ISK",
      symbol: "kr",
      name: "Icelandic krona",
    },
    {
      cc: "JEP",
      symbol: "£",
      name: "Jersey pound",
    },
    {
      cc: "JMD",
      symbol: "$",
      name: "Jamaican dollar",
    },
    {
      cc: "JOD",
      symbol: "د.أ.",
      name: "Jordanian dinar",
    },
    {
      cc: "JPY",
      symbol: "¥",
      name: "Japanese yen",
    },
    {
      cc: "KES",
      symbol: "KSh",
      name: "Kenyan shilling",
    },
    {
      cc: "KGS",
      symbol: "с",
      name: "Kyrgyzstani som",
    },
    {
      cc: "KHR",
      symbol: "៛",
      name: "Cambodian riel",
    },
    {
      cc: "KID",
      symbol: "$",
      name: "Kiribati dollar",
    },
    {
      cc: "KMF",
      symbol: "CF",
      name: "Comorian franc",
    },
    {
      cc: "KPW",
      symbol: "₩",
      name: "North Korean won",
    },
    {
      cc: "KRW",
      symbol: "₩",
      name: "South Korean won",
    },
    {
      cc: "KWD",
      symbol: "د.ك.",
      name: "Kuwaiti dinar",
    },
    {
      cc: "KYD",
      symbol: "$",
      name: "Cayman Islands dollar",
    },
    {
      cc: "KZT",
      symbol: "₸",
      name: "Kazakhstani tenge",
    },
    {
      cc: "LAK",
      symbol: "₭",
      name: "Lao kip",
    },
    {
      cc: "LBP",
      symbol: "ل.ل.",
      name: "Lebanese pound",
    },
    {
      cc: "LKR",
      symbol: "රු or ரூ",
      name: "Sri Lankan rupee",
    },
    {
      cc: "LRD",
      symbol: "$",
      name: "Liberian dollar",
    },
    {
      cc: "LSL",
      symbol: "L",
      name: "Lesotho loti",
    },
    {
      cc: "LYD",
      symbol: "ل.د.",
      name: "Libyan dinar",
    },
    {
      cc: "MAD",
      symbol: "د.م.",
      name: "Moroccan dirham",
    },
    {
      cc: "MDL",
      symbol: "L",
      name: "Moldovan leu",
    },
    {
      cc: "MGA",
      symbol: "Ar",
      name: "Malagasy ariary",
    },
    {
      cc: "MKD",
      symbol: "ден",
      name: "Macedonian denar",
    },
    {
      cc: "MMK",
      symbol: "Ks",
      name: "Myanmar kyat",
    },
    {
      cc: "MNT",
      symbol: "₮",
      name: "Mongolian tögrög",
    },
    {
      cc: "MOP",
      symbol: "MOP$",
      name: "Macanese pataca",
    },
    {
      cc: "MRU",
      symbol: "أ.م.",
      name: "Mauritanian ouguiya",
    },
    {
      cc: "MUR",
      symbol: "रु ",
      name: "Mauritian rupee",
    },
    {
      cc: "MVR",
      symbol: ".ރ",
      name: "Maldivian rufiyaa",
    },
    {
      cc: "MWK",
      symbol: "MK",
      name: "Malawian kwacha",
    },
    {
      cc: "MXN",
      symbol: "$",
      name: "Mexican peso",
    },
    {
      cc: "MYR",
      symbol: "RM",
      name: "Malaysian ringgit",
    },
    {
      cc: "MZN",
      symbol: "MT",
      name: "Mozambican metical",
    },
    {
      cc: "NAD",
      symbol: "$",
      name: "Namibian dollar",
    },
    {
      cc: "NGN",
      symbol: "₦",
      name: "Nigerian naira",
    },
    {
      cc: "NIO",
      symbol: "C$",
      name: "Nicaraguan córdoba oro",
    },
    {
      cc: "NOK",
      symbol: "kr",
      name: "Norwegian krone",
    },
    {
      cc: "NPR",
      symbol: "रू",
      name: "Nepalese rupee",
    },
    {
      cc: "NZD",
      symbol: "$",
      name: "New Zealand dollar",
    },
    {
      cc: "OMR",
      symbol: "ر.ع.",
      name: "Omani rial",
    },
    {
      cc: "PAB",
      symbol: "B/.",
      name: "Panamanian balboa",
    },
    {
      cc: "PEN",
      symbol: "S/.",
      name: "Peruvian sol",
    },
    {
      cc: "PGK",
      symbol: "K",
      name: "Papua New Guinean kina",
    },
    {
      cc: "PHP",
      symbol: "₱",
      name: "Philippine peso",
    },
    {
      cc: "PKR",
      symbol: "Rs",
      name: "Pakistani rupee",
    },
    {
      cc: "PLN",
      symbol: "zł",
      name: "Polish zloty",
    },
    {
      cc: "PND",
      symbol: "$",
      name: "Pitcairn Islands dollar",
    },
    {
      cc: "PRB",
      symbol: "р.",
      name: "Transnistrian ruble",
    },
    {
      cc: "PYG",
      symbol: "₲",
      name: "Paraguayan guaraní",
    },
    {
      cc: "QAR",
      symbol: "ر.ق.",
      name: "Qatari riyal",
    },
    {
      cc: "RON",
      symbol: "L",
      name: "Romanian leu",
    },
    {
      cc: "RSD",
      symbol: "дин",
      name: "Serbian dinar",
    },
    {
      cc: "RUB",
      symbol: "₽",
      name: "Russian ruble",
    },
    {
      cc: "RWF",
      symbol: "R₣",
      name: "Rwandan franc",
    },
    {
      cc: "SAR",
      symbol: "ر.س.",
      name: "Saudi riyal",
    },
    {
      cc: "SBD",
      symbol: "$",
      name: "Solomon Islands dollar",
    },
    {
      cc: "SCR",
      symbol: "Rs",
      name: "Seychellois rupee",
    },
    {
      cc: "SDG",
      symbol: "ج.س.",
      name: "Sudanese pound",
    },
    {
      cc: "SEK",
      symbol: "kr",
      name: "Swedish krona",
    },
    {
      cc: "SGD",
      symbol: "$",
      name: "Singapore dollar",
    },
    {
      cc: "SHP",
      symbol: "£",
      name: "Saint Helena pound",
    },
    {
      cc: "SLL",
      symbol: "Le",
      name: "Sierra Leonean leone",
    },
    {
      cc: "SLS",
      symbol: "Sl",
      name: "Somaliland shilling",
    },
    {
      cc: "SOS",
      symbol: "Ssh",
      name: "Somali shilling",
    },
    {
      cc: "SRD",
      symbol: "$",
      name: "Surinamese dollar",
    },
    {
      cc: "SSP",
      symbol: "SS£",
      name: "South Sudanese pound",
    },
    {
      cc: "STN",
      symbol: "Db",
      name: "Sao Tome dobra",
    },
    {
      cc: "SVC",
      symbol: "₡",
      name: "Salvadoran colón",
    },
    {
      cc: "SYP",
      symbol: "ل.س.",
      name: "Syrian pound",
    },
    {
      cc: "SZL",
      symbol: "L",
      name: "Swazi lilangeni",
    },
    {
      cc: "THB",
      symbol: "฿",
      name: "Thai baht",
    },
    {
      cc: "TJS",
      symbol: "SM",
      name: "Tajikistani somoni",
    },
    {
      cc: "TMT",
      symbol: "T",
      name: "Turkmenistan manat",
    },
    {
      cc: "TND",
      symbol: "د.ت.",
      name: "Tunisian dinar",
    },
    {
      cc: "TOP",
      symbol: "PT",
      name: "Tongan pa'anga",
    },
    {
      cc: "TRY",
      symbol: "₺",
      name: "Turkish lira",
    },
    {
      cc: "TTD",
      symbol: "$",
      name: "Trinidad and Tobago dollar",
    },
    {
      cc: "TVD",
      symbol: "$",
      name: "Tuvaluan dollar",
    },
    {
      cc: "TWD",
      symbol: "圓",
      name: "New Taiwan dollar",
    },
    {
      cc: "TZS",
      symbol: "TSh",
      name: "Tanzanian shilling",
    },
    {
      cc: "UAH",
      symbol: "грн",
      name: "Ukrainian hryvnia",
    },
    {
      cc: "UGX",
      symbol: "Sh",
      name: "Ugandan shilling",
    },
    {
      cc: "USD",
      symbol: "$",
      name: "US dollar",
    },
    {
      cc: "UYU",
      symbol: "$",
      name: "Uruguayan peso",
    },
    {
      cc: "UZS",
      symbol: "сум",
      name: "Uzbekistani som",
    },
    {
      cc: "VED",
      symbol: "Bs.",
      name: "Venezuelan bolívar digital",
    },
    {
      cc: "VES",
      symbol: "Bs.F",
      name: "Venezuelan bolívar",
    },
    {
      cc: "VND",
      symbol: "₫",
      name: "Vietnamese dong",
    },
    {
      cc: "VUV",
      symbol: "VT",
      name: "Vanuatu vatu",
    },
    {
      cc: "WST",
      symbol: "ST",
      name: "Samoan tala",
    },
    {
      cc: "XAF",
      symbol: "Fr.",
      name: "Central African CFA franc",
    },
    {
      cc: "XCD",
      symbol: "$",
      name: "East Caribbean dollar",
    },
    {
      cc: "XOF",
      symbol: "₣",
      name: "West African CFA franc",
    },
    {
      cc: "XPF",
      symbol: "₣",
      name: "CFP franc",
    },
    {
      cc: "YER",
      symbol: "ر.ي.",
      name: "Yemeni rial",
    },
    {
      cc: "ZAR",
      symbol: "R",
      name: "South African rand",
    },
    {
      cc: "ZMW",
      symbol: "ZK",
      name: "Zambian kwacha",
    },
    {
      cc: "ZWB",
      symbol: "$",
      name: "RTGS dollar",
    },
    {
      cc: "ZWL",
      symbol: "$",
      name: "Zimbabwean dollar",
    },
    {
      cc: "Abkhazia",
      symbol: "апсар",
      name: "Abkhazian apsar",
    },
    {
      cc: "Artsakh",
      symbol: "դր.",
      name: "Artsakh dram",
    },
  ],
  policies: {
    permission: {
      "/DiscoverNow": "discovernow",
      "/Discovernow": "discovernow",
      "/discovernow": "discovernow",
      "/locationanalysis": "location_dashboard",
      tpmp: "lsp_profiles",
      "/SynergyNow": "synergynow",
      "/synergynow": "synergynow",
      "/TransportComparison": "comparenow",
      "/transportcomparison": "comparenow",
      "/Home": "home_search",
      "/home": "home_search",
      "/benchmark-now": "benchmarknow",
    },
    credits: {
      "/DiscoverNow": "allowed_searches",
      "/discovernow": "allowed_searches",
      "/locationanalysis": "allowed_locations",
      tpmp: "allowed_profiles",
      "/TransportComparison": "allowed_comparisons",
      "/transportcomparison": "allowed_comparisons",
    },
    Defaults: {
      basic: {
        setting_type: "policy",
        type: "basic",
        location_dashboard: {
          allowed: "yes",
          allowed_locations: 2,
        },
        comparenow: {
          allowed: "no",
        },
        procurenow: {
          allowed: "yes",
          allowed_procurements: 1,
        },
        synergynow: {
          allowed: "yes",
        },
        discovernow: {
          allowed: "yes",
          allowed_searches: 10,
          lsp_limit: 20,
          filter_permission: "no",
        },
        lsp_profiles: {
          allowed: "yes",
          allowed_profiles: 20,
        },
      },
      standard: {
        setting_type: "policy",
        type: "standard",
        location_dashboard: {
          allowed: "yes",
          allowed_locations: 10,
        },
        comparenow: {
          allowed: "yes",
        },
        procurenow: {
          allowed: "yes",
          allowed_procurements: 10,
        },
        synergynow: {
          allowed: "yes",
        },
        discovernow: {
          allowed: "yes",
          allowed_searches: 50,
          lsp_limit: 100,
          filter_permission: "yes",
        },
        lsp_profiles: {
          allowed: "yes",
          allowed_profiles: 50,
        },
      },
      premium: {
        setting_type: "policy",
        type: "premium",
        location_dashboard: {
          allowed: "yes",
          allowed_locations: 20,
        },
        comparenow: {
          allowed: "yes",
        },
        procurenow: {
          allowed: "yes",
          allowed_procurements: 20,
        },
        synergynow: {
          allowed: "yes",
        },
        discovernow: {
          allowed: "yes",
          allowed_searches: 200,
          lsp_limit: 500,
          filter_permission: "yes",
        },
        lsp_profiles: {
          allowed: "yes",
          allowed_profiles: 200,
        },
      },
    },
  },
  restrictedDomains: RestrictedDomains,
  personalEmailDomains: PersonalEmailDomains,

  FileTypes: [
    {
      extension: "doc",
      icon: WORD,
    },
    {
      extension: "docx",
      icon: WORD,
    },
    {
      extension: "pdf",
      icon: PDF,
    },
    {
      extension: "xls",
      icon: EXCEL,
    },
    {
      extension: "xlsx",
      icon: EXCEL,
    },
    {
      extension: "ppt",
      icon: PPT,
    },
    {
      extension: "pptx",
      icon: PPT,
    },
    {
      extension: "csv",
      icon: CSV,
    },
    {
      extension: "txt",
      icon: TEXT,
    },
    {
      extension: "png",
      icon: IMG,
    },
    {
      extension: "invalid",
      icon: INVALID,
    },
  ],

  Pagination: {
    PageSize: 1000,
    PageSize2: 1000,
  },

  Ratings: {
    OutOf: 5,
  },

  StaffJsonMap: [
    { key: "management_staff", label: "Management" },
    { key: "maintenance_staff", label: "Maintainance" },
    { key: "driver", label: "Driver" },
  ],

  Email: {
    regex:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  },

  FileHandlerActions: {
    Upload: "upload",
    Download: "download",
  },
};

export const encryptor = (transporterID = "", shouldEncode) => {
  let characters = "QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm".split(
    "",
  );
  const generateRandomCharcter = () =>
    characters[Math.floor(Math.random() * characters.length)];
  if (shouldEncode) {
    let k = transporterID.split("");
    let encodedID = "";
    k.map((item, index) => {
      encodedID += item;
      for (let i = 0; i <= index; i++) {
        encodedID += generateRandomCharcter();
      }
    });
    return encodedID;
  } else {
    let decodedID = "";
    let startIndex = 0,
      nextIndex = 2;
    while (transporterID.length > startIndex) {
      decodedID += transporterID[startIndex];
      startIndex += nextIndex;
      nextIndex++;
    }
    return decodedID;
  }
};

export const ModuleNames = [
  {
    CompareNow: [
      "compare",
      "comparison",
      "comparing",
      "contrast",
      "juxtapose",
      "differentiate",
      "compare now",
      "comparenow",
      "compare-now",
    ],
    DiscoverNow: [
      "find",
      "discover",
      "find out",
      "discovernow",
      "discover now",
      "discover-now",
    ],
    Profile: ["profile", "sector", "sectors"],
    Benchmark: ["benchmark", "freight", "benchmarknow", "benchmark-now"],
    LocationDashboard: [
      "transporter",
      "lsps",
      "lsp",
      "transporters",
      "location dashboard",
      "location-dashboard",
    ],
    Procurement: [
      "procure",
      "auction",
      "procurenow",
      "lorri-procure",
      "procurenow",
      "procure now",
      "lorri procure",
    ],
    LogisticsNow: ["logisticsnow", "logistics now", "logistics-now"],
  },
];

export const search_suggestion = [
  "Benchmark 10 wheeler truck from mumbai to delhi",
  "Show transporters from mumbai",
  "Show transporters from mumbai to delhi",
  "Show transporters from mumbai to delhi for 32 ft multi axle",
  "Show profile of Transporter ABC",
  "Show transporters in steel",
  "Transporters from mumbai to pune",
  "Rates from mumbai to pune",
  "Transporters in mumbai",
  "Freight benchmark from mumbai to pune for 32 ft multi-axle",
  "Transporters in cement",
];

export const Sectors = [
  {
    name: "AGRICULTURAL PRODUCTS",
    value: { isChecked: false },
    displayName: "AGRICULTURAL PRODUCTS",
  },
  {
    name: "AUTOMOBILE",
    value: { isChecked: false },
    displayName: "AUTOMOBILE",
  },
  { name: "BREWING", value: { isChecked: false }, displayName: "BREWING" },
  {
    name: "BUILDING MATERIAL",
    value: { isChecked: false },
    displayName: "BUILDING MATERIAL",
  },
  { name: "CEMENT", value: { isChecked: false }, displayName: "CEMENT" },
  { name: "CERAMICS", value: { isChecked: false }, displayName: "CERAMICS" },
  { name: "CHEMICAL", value: { isChecked: false }, displayName: "CHEMICAL" },
  {
    name: "CONSTRUCTION",
    value: { isChecked: false },
    displayName: "CONSTRUCTION",
  },
  { name: "ECOMMERCE", value: { isChecked: false }, displayName: "ECOMMERCE" },
  {
    name: "ELECTRICALS",
    value: { isChecked: false },
    displayName: "ELECTRICALS",
  },
  {
    name: "ELECTRONICS",
    value: { isChecked: false },
    displayName: "ELECTRONICS",
  },
  {
    name: "ENGINEERING SERVICES",
    value: { isChecked: false },
    displayName: "ENGINEERING SERVICES",
  },
  {
    name: "FASHION AND CLOTHING",
    value: { isChecked: false },
    displayName: "FASHION AND CLOTHING",
  },
  { name: "FMCD", value: { isChecked: false }, displayName: "FMCD" },
  { name: "FMCG", value: { isChecked: false }, displayName: "FMCG" },
  { name: "GLASS", value: { isChecked: false }, displayName: "GLASS" },
  {
    name: "HEALTHCARE",
    value: { isChecked: false },
    displayName: "HEALTHCARE",
  },
  {
    name: "INDUSTRIAL AUTOMATION",
    value: { isChecked: false },
    displayName: "INDUSTRIAL AUTOMATION",
  },
  {
    name: "INFRASTRUCTURE",
    value: { isChecked: false },
    displayName: "INFRASTRUCTURE",
  },
  { name: "LOGISTICS", value: { isChecked: false }, displayName: "LOGISTICS" },
  { name: "LUGGAGE", value: { isChecked: false }, displayName: "LUGGAGE" },
  {
    name: "MANUFACTURING",
    value: { isChecked: false },
    displayName: "MANUFACTURING",
  },
  // {name:'MANUFACTURING EXECUTION SYSTEM', value:{isChecked:false}, displayName:'MANUFACTURING EXECUTION SYSTEM'},
  {
    name: "METALS AND MINING",
    value: { isChecked: false },
    displayName: "METALS AND MINING",
  },
  {
    name: "OIL AND GAS",
    value: { isChecked: false },
    displayName: "OIL AND GAS",
  },
  { name: "PACKAGING", value: { isChecked: false }, displayName: "PACKAGING" },
  { name: "PAINTS", value: { isChecked: false }, displayName: "PAINTS" },
  { name: "PAPER", value: { isChecked: false }, displayName: "PAPER" },
  {
    name: "PHARMACEUTICAL",
    value: { isChecked: false },
    displayName: "PHARMACEUTICAL",
  },
  { name: "PLASTICS", value: { isChecked: false }, displayName: "PLASTICS" },
  {
    name: "PRINTING AND MINTING",
    value: { isChecked: false },
    displayName: "PRINTING AND MINTING",
  },
  {
    name: "RAW MATERIAL",
    value: { isChecked: false },
    displayName: "RAW MATERIAL",
  },
  { name: "STEEL", value: { isChecked: false }, displayName: "STEEL" },
  {
    name: "TECHNOLOGY",
    value: { isChecked: false },
    displayName: "TECHNOLOGY",
  },
  { name: "TELECOM", value: { isChecked: false }, displayName: "TELECOM" },
  { name: "TEXTILE", value: { isChecked: false }, displayName: "TEXTILE" },
  { name: "TYRE", value: { isChecked: false }, displayName: "TYRE" },
];

export const Countries = [
  {
    code: "IN",
    name: "India",
    value: { isChecked: false },
    displayName: "India",
    flagUrl: "/static/media/in.7fdfdb85.svg",
  },
  {
    code: "AU",
    name: "Australia",
    value: { isChecked: false },
    displayName: "Australia",
    flagUrl: "/static/media/au.ecef4318.svg",
  },
];

export const Zones = [
  { name: "East", value: { isChecked: false }, displayName: "East" },
  { name: "West", value: { isChecked: false }, displayName: "West" },
  { name: "North", value: { isChecked: false }, displayName: "North" },
  { name: "South", value: { isChecked: false }, displayName: "South" },
  {
    name: "Northeast",
    value: { isChecked: false },
    displayName: "Northeast",
  },
];

export const RatingParameters = [
  {
    id: "Reliability",
    name: "Reliability",
    rating: 0,
    description: "How reliable is the transporter?",
  },
  {
    id: "Season/ad-hocSupport",
    name: "Season/ad-hoc Support",
    rating: 0,
    description: "Ability to support in Season/ad-hoc requirements",
  },
  {
    id: "ServiceLevelAdherence",
    name: "Service Level Adherence",
    rating: 0,
    description: "On-time and efficient truck placement",
  },
  {
    id: "CostCompetitiveness",
    name: "Cost Competitiveness",
    rating: 0,
    description: "How competitive are this transporters rates?",
  },
];

export const VASParameters = [
  {
    id: 1,
    class: "fa fa-star raiting-icon-color",
    name: "Get Industry Ratings for your Transporters",
  },
  {
    id: 2,
    class: "fa fa-industry industry-icon-color",
    name: "Discover Industry Benchmarks",
  },
  {
    id: 3,
    class: "fa fa-truck logistic-partner-icon-color",
    name: "Find your Right Logistics Partner",
  },
  {
    id: 4,
    class: "fa fa-cogs explorer-icon-color",
    name: "Request for Information(RFI) for Transporters",
  },
];

export const RoutePaths = {
  // Auth / account
  MyAccount: "/myAccount",
  ChangePassword: "/change-password",
  ForgotPassword: "/forgot-password",
  Login: "/login",
  Sitemap: "/sitemap",

  // Profile / billing
  CompanyProfile: "/companyprofilenew/generalinfo",
  Billing: "/billing",
  Dashboard: "/dashboard",
  LorriMail: "/LorriInMail",

  // Approval
  ApprovalProcurement: "/approvalcontrol/procurement",
  ApprovalAuction: "/approvalcontrol/auction",
  ApprovalSpot: "/approvalcontrol/spot",
  ApprovalIndent: "/approvalcontrol/indent",

  // Transporter
  MyTransporters: "/myTransporters",
  DiscoverNow: "/discovernow",
  CompareNow: "/TransportComparison",
  ContractNow: "/contractnow",
  SearchEngine: "/SearchEngine",
  SearchTransportersMobile: "/Home",

  // Benchmark
  BenchmarkNow: "/LoRRIBenchmark",
  LoRRIBenchmark: "/LoRRIBenchmark",
  LockInYourSavings: "/lockinyoursavings",

  // Analytics
  SynergyNow: "/synergynow",
  RFQCalender: "/rfqcalender",
  LocationDashboard: "/locationdashboard",

  // Spot
  SpotEnquiries: "/trucks/enquiries",
  SpotDashboard: "/trucks/dashboard",

  // Search
  SearchResults: "/SearchResults",
  FreightRates: "/freightrates",
  Location: "/location",

  // Operations
  IndentRequest: "/indentrequest",
  IndentRequestMobile: "/indents/requestdashboard",
  TrackingDashboard: "/tracking_dashboard",
  MasterDashboard: "/master_dashboard",
  GigoGateIn: "/gigo/gateIn",
  Invoice: "/invoice",
  PlanningDashboard: "/planning/dashboard",
  Planning: "/planning",
  CapacityPlanning: "/capacityplanning/fileupload",
};

export const REDIRECT_ROUTE_MAP = new Map(
  Object.values(RoutePaths).map(p => {
    const segment = p.split('/')[1];
    return [segment.toLowerCase(), segment];
  })
);

export function resolveScreenParam(search) {
  const param = new URLSearchParams(search).get('screen');
  return param ? (REDIRECT_ROUTE_MAP.get(param.toLowerCase()) ?? null) : null;
}

export const isMobile = () => {
  return window.innerWidth > 600 ? false : true;
};

/**
 * DO NOT USE EMPTY FUNCTION
 * @param {null}
 * @returns {null}
 */
export const Activity = (
  data,
  activitytype = "",
  userEmail = "",
  companyname = "",
  userName = "",
  ipAddress = sessionStorage.getItem("ClientIP"),
) => {
  if (activitytype === "Sign-Out" || activitytype === "Sign-In") {
    return Axios.post(Urls.logURL, {
      activity: "Session Logging",
      application: "Lorri",
      user_email: userEmail,
      user_name: userName,
      company_name: companyname,
      ip: ipAddress,
      session_log: data,
      environment: ENV,
      activity_type: activitytype,
    });
  }
};

export const currentRequestTimeStamp = () => new Date().toISOString();

export const getCurrentPath = () => window.location.pathname;

export const ActivityString = {
  AddTransporter: "Add Transporter button clicked",
  ClickMyTransporter: "My Transporter page viewed",
  DeleteTransporter: "Delete Transporter button clicked",
  SubmitTransporterList: "Submit button clicked",
  SearchMyTransporter: "Transporter searched",
  LocationDashboard: "Location Dashboard page viewed",
  ResetButton: "Reset button clicked",
  GetMoreCredit: "Get more credit button clicked",
  HistoryButton: "History button clicked",
  PrevButtonLocationDashboard: "Previous button clicked",
  NextButtonLocationDashboard: "Next button clicked",
  MyAccountPageView: "My Account page viewed",
  benchmarknow: "My Freight Benchmark  page viewed",
  ReferenceCheckButton: "Reference check button clicked",
  DeleteTransporterButton: "Delete transporter button clicked",
  UploadFile: "Upload File button clicked",
  DownloadFile: "Download File button clicked",
  ReferMore: "Refer More clicked",
  CompareNowPageView: "CompareNow page viewed",
  ShareProfileButton: "Share Profile button clicked",
  DiscoverNowPageView: "DiscoverNow page viewed",
  LogOut: "Logout button clicked",
  ContactUs: "Contact us button clicked",
  SubmitQuery: "Submit query button clicked",
  ReviewFeedbackPageView: "Review and feedback page viewed",
  SubmitYourReviewTab: "Submit your review tab clicked",
  ReportABugTab: "Report a bug tab clicked",
  ShowSuggestionTab: "Suggestions tab clicked",
  SubmitReview: "Review submitted",
  SubmitBug: "Bug submitted",
  SubmitIdea: "Suggestion submitted",
  SynergyNow: "Synergy Now Page Viewed",
};

export const numberWithCommas = (x) => {
  if (x) {
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // var x=12345678;
    x = x.toString();
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== "") lastThree = "," + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return res;
  } else {
    return 0;
  }
};

export const numberAndDecimalWithCommas = (x) => {
  if (x || x === 0) {
    const parts = x.toString().split(".");
    let integerPart = parts[0];
    let decimalPart = parts[1];
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let formattedNumber = integerPart;
    if (decimalPart) {
      formattedNumber += "." + decimalPart;
      // formattedNumber = parseFloat(formattedNumber).toFixed(2);
    }
    return formattedNumber;
  } else {
    return 0;
  }
};

export const DateFormatter1 = (inputdate) => {
  var date = new Date(inputdate);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var dt = date.getDate();
  // var time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  return <div>{dt + "-" + month + "-" + year}</div>;
};

export const parseUTCDate = (inputdate) => {
  if (!inputdate) return null;
  if (inputdate instanceof Date) return inputdate;

  let date;
  if (typeof inputdate === "number") {
    date = new Date(inputdate);
  } else if (typeof inputdate === "string") {
    const trimmed = inputdate.trim();
    if (/^\d+$/.test(trimmed)) {
      date = new Date(Number(trimmed));
    } else {
      let cleaned = trimmed.replace(" ", "T");
      cleaned = cleaned.replace(/\.(\d{1,3})\d*/, ".$1");

      // Check for identifying the timezone format
      const hasTimezone = cleaned.includes("Z") ||
        cleaned.includes("z") ||
        (cleaned.length > 10 && (cleaned.slice(10).includes("+") || cleaned.slice(10).includes("-")));
      if (!hasTimezone) {
        cleaned += "Z";
      }
      date = new Date(cleaned);
    }
  }

  if (date && !isNaN(date.getTime())) {
    return date;
  }
  return null;
};

export const NegotiateDateFormatter = (inputdate) => {
  if (!inputdate) return "";
  const date = parseUTCDate(inputdate);
  if (!date) return "";

  // UTC + 5.5 hrs
  const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);

  var year = istDate.getUTCFullYear();
  var month = istDate.getUTCMonth() + 1;
  var dt = istDate.getUTCDate();

  let hour = istDate.getUTCHours();
  let minute = istDate.getUTCMinutes();
  let ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12;
  hour = hour ? hour : 12; // the hour '0' should be '12'

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  if (minute < 10) {
    minute = "0" + minute;
  }
  let hourStr = hour < 10 ? "0" + hour : hour;

  return (
    <>
      <div>
        {dt + "-" + month + "-" + year}, {hourStr + ":" + minute + " " + ampm}
      </div>
    </>
  );
};



export const DateFormatter2 = (inputdate) => {
  if (inputdate !== undefined && inputdate !== "" && inputdate !== null) {
    var date = new Date(inputdate);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var dt = date.getDate();
    // var time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return dt + "-" + month + "-" + year;
  }
};

export const DateFormatter3 = (inputdate) => {
  var date = new Date(inputdate);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var dt = date.getDate();
  // var time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  return year + "-" + month + "-" + dt;
};

export const DateFormatter4 = (inputdate) => {
  const date = new Date(inputdate);
  if (isNaN(date)) return;

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const time = date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return <div>{`${day}-${month}-${year}, ${time}`}</div>;
};

export const DateFormatter5 = (inputdate) => {
  if (inputdate !== undefined && inputdate !== "" && inputdate !== null) {
    var date = new Date(inputdate);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var dt = date.getDate();
    var time = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return (
      <>
        <span style={{ fontSize: "11px", fontStyle: "italic" }}>
          {dt + "/" + month + "/" + year}
        </span>
        <br />
        <span style={{ fontSize: "11px", fontStyle: "italic" }}>{time}</span>
      </>
    );
  } else {
    return <span></span>;
  }
};

export const DateFormatter6 = (inputdate) => {
  if (inputdate !== undefined && inputdate !== "" && inputdate !== null) {
    var date = new Date(inputdate);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var dt = date.getDate();
    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return (
      <>
        <span>{dt + "/" + month + "/" + year}</span>
      </>
    );
  } else {
    return <span></span>;
  }
};

export const formatDateForDisplay = (inputDate) => {
  const date = parseUTCDate(inputDate);
  if (!date) return "";

  const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);

  let hour = istDate.getUTCHours();
  const amOrPm = hour < 12 ? "AM" : "PM";
  if (hour > 12) hour -= 12;
  if (hour === 0) hour = 12; // Midnight case

  return `${String(istDate.getUTCDate()).padStart(2, "0")}-${String(
    istDate.getUTCMonth() + 1,
  ).padStart(2, "0")}-${istDate.getUTCFullYear()}, ${hour}:${String(
    istDate.getUTCMinutes(),
  ).padStart(2, "0")} ${amOrPm}`;
};

export const isValidCompanyName = (value) =>
  value && new RegExp(/^[A-Za-z0-9\s.,'&()-]+$/).test(value);

export const isValidWebUrl = (value) =>
  value &&
  new RegExp(
    /^(?:(?:https?):\/\/)?(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/,
  ).test(value);

export const isValidYear = (value) =>
  value && new RegExp(/\b\d{4}\b/).test(value);

export const hasSpecialCharacters = (value) =>
  value && new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?\.]/).test(value);

export const isNumbers = (value) => value && new RegExp(/^\d+$/).test(value);

export const spotFilterOptions = [
  { label: "Today", value: 1 },
  { label: "7 days", value: 7 },
  { label: "15 days", value: 15 },
  { label: "1 month", value: 30 },
  { label: "3 months", value: 90 },
];

export const expiryDateFormatter = (data, expiryhours) => {
  let expirydate = new Date();
  const hr = expirydate.getHours();
  const parsedHours = parseInt(expiryhours);
  const hours = isNaN(parsedHours) ? 72 : parsedHours;
  expirydate.setHours(hr + hours);
  var final_day = (
    "0" + expirydate.toISOString().split("T")[0].split("-")[2]
  ).slice(-2);
  var month = (
    "0" + expirydate.toISOString().split("T")[0].split("-")[1]
  ).slice(-2);
  var year = expirydate.toISOString().split("T")[0].split("-")[0];
  var final_hr = (
    "0" + expirydate.toISOString().split("T")[1].split(":")[0]
  ).slice(-2);
  var min = ("0" + expirydate.toISOString().split("T")[1].split(":")[1]).slice(
    -2,
  );
  data.expiry_date = `${year}-${month}-${final_day} ${final_hr}:${min}:00.000000`;
  return data;
};

export const ENABLE_FRONTEND_SMS = ENABLE_SMS;

export const GRAD = {
  indigo: ["#393185", "#4D45A8", "#6B64C0", "#8D87D0", "#B1AEE4", "#D5D3F2"],
  sky: ["#1AA6DF", "#30B5E8", "#56C5EE", "#80D4F3", "#AAE3F7", "#CFF0FB"],
  green: ["#54AF3A", "#6DC256", "#88CF75", "#A5DC96", "#C4EAB8", "#E1F5D8"],
  teal: ["#0E9B8A", "#22B09E", "#44C4B3", "#72D6C8", "#A4E6DE", "#D0F4F0"],
};

export const LORRI_NUMBERS = {
  NUMBER_OF_ROUTES: "80,000",
  NUMBER_OF_LSP: "2400",
  AMOUNT_OF_FREIGHT_ANALYZED: "₹22,000 Cr"
}